import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(html): any {
    if (html == null) {
      return "";
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/safe-html.pipe.ts